import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { takeUntil } from 'rxjs/operators';

import { BaseComponent, BaseEditFormComponent } from '../../../../tms-shared';
import { Customer, CustomerKeyAndName, CustomerService, TmsFormlyService } from '../../../../app-shared';
import { UserService } from '../../services';
import { AuthService } from '../../../../auth';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrl: './user-details.component.scss',
})
export class UserDetailsComponent extends BaseComponent implements OnInit {
  @ViewChild(BaseEditFormComponent) form: BaseEditFormComponent;
  @Output() saved = new EventEmitter<void>();

  fields: FormlyFieldConfig[];

  private isAdmin: boolean;

  constructor(
    public userService: UserService,
    private customerService: CustomerService,
    private authService: AuthService,
    private formlyService: TmsFormlyService,
  ) {
    super();
  }

  ngOnInit() {
    this.isAdmin = this.authService.isAdmin;
    this.getFields();
  }

  private getFields() {
    this.fields = this.formlyService.twoColumnGrid(
      [
        this.formlyService.text('firstName', $localize`First Name`, undefined, { required: true, maxLength: 100 }),
        this.formlyService.text('lastName', $localize`Last Name`, undefined, { required: true, maxLength: 100 }),
        this.formlyService.textReadonly(
          'username',
          $localize`Username`,
          undefined,
          undefined,
          (field: FormlyFieldConfig) => !field.model?.id,
        ),
        this.formlyService.textReadonly(
          'emailAddress',
          $localize`Email Address`,
          undefined,
          undefined,
          (field: FormlyFieldConfig) => !field.model?.id,
        ),
        this.formlyService.text(
          'emailAddress',
          'Email Address',
          undefined,
          { required: true, maxLength: 256 },
          (field: FormlyFieldConfig) => !!field.model?.id,
          undefined,
          [Validators.email],
          undefined,
          {
            notExists: {
              expression: (control: UntypedFormControl, field: FormlyFieldConfig) =>
                this.userService.checkEmail(control.value),
            },
          },
        ),
        this.formlyService.checkbox('disabled', $localize`Disabled`, undefined, { readonly: !this.isAdmin }),
        this.formlyService.checkbox('amendOtherComments', $localize`Amend Other Users Comments`)
      ],
      [
        ...this.formlyService.customerSearch(
          'customerSearch',
          'customerId',
          undefined,
          (model: Customer) => this.changeCustomer(model),
          () => this.clearCustomer(),
        ),
        this.formlyService.textReadonly('customerKey', $localize`Customer Account`),
        this.formlyService.textReadonly('customerName', $localize`Customer`),
      ],
    );
  }

  private changeCustomer(model: Customer) {
    this.customerService
      .getCustomerKeyAndName(model.id)
      .pipe(takeUntil(this.destroy$))
      .subscribe((customer: CustomerKeyAndName) => this.form.updateModel(customer));
  }

  private clearCustomer() {
    this.form.updateModel({
      customerId: undefined,
      customerKey: undefined,
      customerName: undefined,
    });
  }
}
